import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';
import toast from 'react-hot-toast';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import './KompresorListesi.css';




const MUSTERI_BILGILERI = [
  { key: 'mail', label: 'Mail' },
  { key: 'adres', label: 'Adres' },
  { key: 'yetkili', label: 'Yetkili' },
  { key: 'yetkiliTel', label: 'Yetkili Tel' }
];




const KOMPRESOR_BILGILERI = [
  { key: 'imalYili', label: 'Kompresör İmal Yılı' },
  { key: 'bakimTarihi', label: 'Bakım Tarihi' },
  { key: 'sonBakimTarihi', label: 'Son Bakım Tarihi' },
  { key: 'toplamSaat', label: 'Toplam Çalışma Saati' },
  { key: 'yukteSaat', label: 'Yükte Çalışma Saati' },
  { key: 'bostaSaat', label: 'Boşta Çalışma Saati' },
  { key: 'gunlukCalismaSaati', label: 'Günlük Çalışma Saati' },
  { key: 'bakimDongusuA', label: 'A Bakımı Döngüsü (saat)' },
  { key: 'revizyonSaat', label: 'Revizyon Saati' },
  { key: 'modulKart', label: 'Modül Kart Tipi / Şifre' },
  { key: 'elementSicaklik', label: 'Element Sıcaklık' }
];




const PARCA_ALANLARI = [
  { key: 'seperator', label: 'Seperatör' },
  { key: 'yagFiltresi', label: 'Yağ Filtresi' },
  { key: 'havaFiltresi', label: 'Hava Filtresi' },
  { key: 'yagTipi', label: 'Yağ Tipi ve Miktarı' },
  { key: 'mpv', label: 'MPV' },
  { key: 'oilStopValf', label: 'OIL STOP VALF' },
  { key: 'cekvalf', label: 'ÇEKVALF' },
  { key: 'termostat', label: 'TERMOSTAT' },
  { key: 'kece', label: 'KEÇE' },
  { key: 'keceBurcu', label: 'KEÇE BURCU' },
  { key: 'suTahliye', label: 'SU TAHLİYE (DRAIN VALF)' },
  { key: 'kurutucuVeFiltre', label: 'KURUTUCU VE HAT FİLTRE' },
  { key: 'caplinKayis', label: 'CAPLİN-KAYIŞ' },
  { key: 'emisValfi', label: 'EMİŞ VALFİ' },
  { key: 'regulatingValf', label: 'REGULATING VALF' }
];




const REVIZYON_ALANLARI = [
  { key: 'ERKEK ROTOR ÖN', label: 'ERKEK ROTOR ÖN RULMAN' },
  { key: 'ERKEK ROTOR ARKA', label: 'ERKEK ROTOR ARKA RULMAN' },
  { key: 'DİŞİ ROTOR ÖN', label: 'DİŞİ ROTOR ÖN RULMAN' },
  { key: 'DİŞİ ROTOR ARKA', label: 'DİŞİ ROTOR ARKA RULMAN' },
  { key: 'elektrikMotor', label: 'ELEKTRİK MOTOR RULMANI' },
  { key: 'FAN MOTOR R.', label: 'FAN MOTOR RULMANI' }
];




const ALANLAR = [
  ...MUSTERI_BILGILERI,
  ...KOMPRESOR_BILGILERI,
  ...PARCA_ALANLARI,
  ...REVIZYON_ALANLARI
];




const SEKMELER = [
  { id: 'detay', label: '📄 Detaylar' },
  { id: 'parcalar', label: '🔧 Parçalar & Tedarikçiler' },
  { id: 'aksamlar', label: '⭕ Aksamlar' },
  { id: 'revizyon', label: '🛠️ Revizyon' },
  { id: 'gallery', label: '📸 Galeri' }
];




const TR_HARF_MAP = {
  ç: 'c',
  ğ: 'g',
  ş: 's',
  ı: 'i',
  ö: 'o',
  ü: 'u',
  â: 'a',
  î: 'i',
  û: 'u'
};




const normalizeTr = (text) =>
  (text ?? '')
    .toString()
    .toLowerCase()
    .replace(/[çğşıöüâîû]/g, (m) => TR_HARF_MAP[m])
    .replace(/[^a-z0-9]/g, '');




const parseFiyat = (fiyat) => {
  if (fiyat === null || fiyat === undefined) return NaN;




  const ham = fiyat.toString().replace(/[\s€]/g, '');




  if (!ham || !/^-?[\d.,]+$/.test(ham)) return NaN;




  let s = ham;




  const isaret = s.startsWith('-') ? '-' : '';




  if (isaret) s = s.slice(1);




  if (!s) return NaN;




  const sonNokta = s.lastIndexOf('.');
  const sonVirgul = s.lastIndexOf(',');
  let sayiMetni = null;




  if (sonNokta !== -1 && sonVirgul !== -1) {
    if (sonVirgul > sonNokta) {
      const tam = s.slice(0, sonVirgul);
      const ond = s.slice(sonVirgul + 1);




      if (!/^\d{1,3}(\.\d{3})+$/.test(tam) || !/^\d{1,2}$/.test(ond)) {
        return NaN;
      }




      sayiMetni = tam.replace(/\./g, '') + '.' + ond;
    } else {
      const tam = s.slice(0, sonNokta);
      const ond = s.slice(sonNokta + 1);




      if (!/^\d{1,3}(,\d{3})+$/.test(tam) || !/^\d{1,2}$/.test(ond)) {
        return NaN;
      }




      sayiMetni = tam.replace(/,/g, '') + '.' + ond;
    }
  } else if (sonVirgul !== -1) {
    const tam = s.slice(0, sonVirgul);
    const ond = s.slice(sonVirgul + 1);




    if (!/^\d+$/.test(tam) || !/^\d{1,2}$/.test(ond)) return NaN;




    sayiMetni = tam + '.' + ond;
  } else if (sonNokta !== -1) {
    if (/^\d{1,3}(\.\d{3}){2,}$/.test(s)) {
      sayiMetni = s.replace(/\./g, '');
    } else {
      const tam = s.slice(0, sonNokta);
      const ond = s.slice(sonNokta + 1);




      if (!/^\d+$/.test(tam) || !/^\d{1,2}$/.test(ond)) return NaN;




      sayiMetni = s;
    }
  } else {
    if (!/^\d+$/.test(s)) return NaN;




    sayiMetni = s;
  }




  const sayi = Number(isaret + sayiMetni);




  return Number.isFinite(sayi) ? sayi : NaN;
};




const temizFiyat = (fiyat) =>
  (fiyat ?? '').toString().replace(/[^\d.,]/g, '');




const guvenliDosyaAdi = (...parcalar) =>
  parcalar
    .filter(Boolean)
    .join('_')
    .replace(/[^\p{L}\p{N}\-_]+/gu, '_');




const kayitKimligi = (kayit) => {
  if (!kayit) return undefined;




  if (kayit.id !== undefined && kayit.id !== null) {
    return `id:${kayit.id}`;
  }




  return `k:${kayit.firma}|${kayit.model}|${kayit.seriNo}`;
};




const fetchFontBase64 = async (url) => {
  const res = await fetch(url);




  if (!res.ok) {
    throw new Error(`Font yüklenemedi (HTTP ${res.status})`);
  }




  const blob = await res.blob();




  const dataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();




    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Font dosyası okunamadı'));
    reader.readAsDataURL(blob);
  });




  return dataUrl.split(',')[1];
};




const OnayModal = ({ acik, mesaj, onCevap }) => {
  if (!acik) return null;




  return (
    <div className="modal-overlay modal-overlay-high" onClick={() => onCevap(false)}>
      <div
        className="modal-content modal-notlar"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-notlar-header">
          <h3>⚠️ Onay Gerekli</h3>




          <button className="modal-close-btn" onClick={() => onCevap(false)}>
            ×
          </button>
        </div>




        <div className="modal-notlar-content" style={{ whiteSpace: 'pre-line' }}>
          {mesaj}
        </div>




        <div className="modal-footer">
          <button className="modal-delete-btn" onClick={() => onCevap(true)}>
            Evet, Devam Et
          </button>




          <button className="modal-pdf-btn" onClick={() => onCevap(false)} autoFocus>
            Vazgeç
          </button>
        </div>
      </div>
    </div>
  );
};




const KlonlamaModal = ({ acik, kapat, kaynakKayitlar, onKlonla, bekliyor }) => {
  const [seciliKaynak, setSeciliKaynak] = useState(null);
  const [yeniFirma, setYeniFirma] = useState('');
  const [yeniSeriNo, setYeniSeriNo] = useState('');
  const [arama, setArama] = useState('');
  const [listeAcik, setListeAcik] = useState(false);
  const aramaKapsayiciRef = useRef(null);




  const kaynaklar = useMemo(
    () =>
      kaynakKayitlar.filter(
        (k) => k.parcalar && Object.keys(k.parcalar).length > 0
      ),
    [kaynakKayitlar]
  );




  const filtrelenmisKaynaklar = useMemo(() => {
    const anahtar = normalizeTr(arama);




    if (!anahtar) return kaynaklar;




    return kaynaklar.filter((k) =>
      [k.firma, k.model, k.seriNo].some(
        (v) => v && normalizeTr(v).includes(anahtar)
      )
    );
  }, [kaynaklar, arama]);




  /* Dış tıklama — liste kapanır */
  useEffect(() => {
    if (!listeAcik) return;




    const handleDisTiklama = (e) => {
      if (
        aramaKapsayiciRef.current &&
        !aramaKapsayiciRef.current.contains(e.target)
      ) {
        setListeAcik(false);




        if (!seciliKaynak) {
          setArama('');
        }
      }
    };




    document.addEventListener('mousedown', handleDisTiklama);




    return () =>
      document.removeEventListener('mousedown', handleDisTiklama);
  }, [listeAcik, seciliKaynak]);




  const handleSec = (kayit) => {
    setSeciliKaynak(kayit);
    setArama('');
    setListeAcik(false);
  };




  const handleKlonla = async () => {
    if (!seciliKaynak || !yeniFirma.trim() || !yeniSeriNo.trim()) {
      toast.error('⚠️ Kaynak, firma ve seri no gerekli.');
      return;
    }




    const basarili = await onKlonla(
      seciliKaynak,
      yeniFirma.trim(),
      yeniSeriNo.trim()
    );




    if (basarili) {
      setSeciliKaynak(null);
      setYeniFirma('');
      setYeniSeriNo('');
      setArama('');
      kapat();
    }
  };




  if (!acik) return null;




  return (
    <div className="modal-overlay" onClick={kapat}>
      <div
        className="modal-content klonlama-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 className="details-title">📋 Şablondan Klonla</h3>




          <button className="modal-close" onClick={kapat}>
            ×
          </button>
        </div>




        <div className="klonlama-body">
          {/* Kaynak seçimi — aramalı dropdown */}
          <div className="form-group klonlama-kaynak-grup">
            <label>Kaynak Kompresör Seç</label>




            <div
              className="klonlama-arama-kapsayici"
              ref={aramaKapsayiciRef}
            >
              <input
                type="text"
                className="klonlama-arama-input"
                placeholder="🔍 Firma, model veya seri no ara..."
                value={
                  seciliKaynak && !listeAcik
                    ? `${seciliKaynak.firma} - ${seciliKaynak.model} (${seciliKaynak.seriNo})`
                    : arama
                }
                onChange={(e) => {
                  setArama(e.target.value);
                  setListeAcik(true);
                  setSeciliKaynak(null);
                }}
                onFocus={() => setListeAcik(true)}
                onClick={(e) => {
                  if (seciliKaynak) {
                    setSeciliKaynak(null);
                    setArama('');
                    setListeAcik(true);
                    e.target.select();
                  }
                }}
              />




              {listeAcik && (
                <div className="klonlama-liste">
                  {filtrelenmisKaynaklar.length === 0 ? (
                    <div className="klonlama-liste-bos">
                      Sonuç bulunamadı
                    </div>
                  ) : (
                    filtrelenmisKaynaklar.map((k) => (
                      <button
                        key={kayitKimligi(k)}
                        type="button"
                        className="klonlama-liste-item"
                        onClick={() => handleSec(k)}
                      >
                        <span className="klonlama-liste-firma">
                          {k.firma}
                        </span>




                        <span className="klonlama-liste-detay">
                          {k.model} · {k.seriNo}
                        </span>




                        <span className="klonlama-liste-badge">
                          {Object.values(k.parcalar || {}).reduce(
                            (t, arr) => t + (arr?.length || 0),
                            0
                          )}{' '}
                          parça
                        </span>
                      </button>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>




          {/* Önizleme */}
          {seciliKaynak && (
            <div className="kaynak-onizleme">
              <p>
                <strong>Kaynak:</strong> {seciliKaynak.firma} -{' '}
                {seciliKaynak.model}
              </p>




              <p>
                <strong>Parça Sayısı:</strong>{' '}
                {Object.values(seciliKaynak.parcalar || {}).reduce(
                  (t, arr) => t + (arr?.length || 0),
                  0
                )}
              </p>
            </div>
          )}




          {/* Yeni kayıt bilgileri */}
          <div className="form-group">
            <label>Yeni Firma Adı *</label>




            <input
              type="text"
              value={yeniFirma}
              onChange={(e) => setYeniFirma(e.target.value)}
              placeholder="Firma adı"
            />
          </div>




          <div className="form-group">
            <label>Yeni Seri No *</label>




            <input
              type="text"
              value={yeniSeriNo}
              onChange={(e) => setYeniSeriNo(e.target.value)}
              placeholder="Seri numarası"
            />
          </div>




          <button
            onClick={handleKlonla}
            className="btn-klonla"
            disabled={bekliyor}
          >
            {bekliyor ? '⏳ Klonlanıyor...' : '📋 Klonla'}
          </button>
        </div>
      </div>
    </div>
  );
};




const KompresorListesi = () => {
  const [darkMode, setDarkMode] = useState(() => {
    try {
      return localStorage.getItem('theme') === 'dark';
    } catch {
      return false;
    }
  });




  const [kayitlar, setKayitlar] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [detayModal, setDetayModal] = useState(null);
  const [activeTab, setActiveTab] = useState('detay');
  const [aktifFoto, setAktifFoto] = useState(null);
  const [zoomMode, setZoomMode] = useState('fit');
  const [ozelNotlarGoruntule, setOzelNotlarGoruntule] = useState(null);
  const [klonlamaModalAcik, setKlonlamaModalAcik] = useState(false);
  const [klonBekliyor, setKlonBekliyor] = useState(false);
  const [loading, setLoading] = useState(true);




  const [onay, setOnay] = useState(null);
  const onayResolveRef = useRef(null);




  const onayIste = useCallback(
    (mesaj) =>
      new Promise((resolve) => {
        onayResolveRef.current?.(false);
        onayResolveRef.current = resolve;
        setOnay({ mesaj });
      }),
    []
  );




  const onayCevapla = useCallback((cevap) => {
    onayResolveRef.current?.(cevap);
    onayResolveRef.current = null;
    setOnay(null);
  }, []);




  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode);




    try {
      localStorage.setItem('theme', darkMode ? 'dark' : 'light');
    } catch {}
  }, [darkMode]);




  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key !== 'Escape') return;




      if (onay) {
        onayCevapla(false);
        return;
      }




      if (aktifFoto) {
        setAktifFoto(null);
        setZoomMode('fit');
        return;
      }




      if (ozelNotlarGoruntule !== null) {
        setOzelNotlarGoruntule(null);
        return;
      }




      setDetayModal(null);
      setKlonlamaModalAcik(false);
    };




    window.addEventListener('keydown', handleEsc);




    return () => window.removeEventListener('keydown', handleEsc);
  }, [onayCevapla, onay, aktifFoto, ozelNotlarGoruntule]);




  useEffect(() => {
    const handleKey = (e) => {
      if (!aktifFoto) return;




      if (e.key === '+' || e.key === '=') {
        e.preventDefault();




        setZoomMode((prev) =>
          prev === 'fit'
            ? 'zoom-in'
            : prev === 'zoom-in'
            ? 'zoom-out'
            : 'fit'
        );
      } else if (e.key === '-' || e.key === '_') {
        e.preventDefault();




        setZoomMode((prev) =>
          prev === 'zoom-out'
            ? 'zoom-in'
            : prev === 'zoom-in'
            ? 'fit'
            : 'zoom-out'
        );
      }
    };




    window.addEventListener('keydown', handleKey);




    return () => window.removeEventListener('keydown', handleKey);
  }, [aktifFoto]);




  const normalizeKayitlar = useCallback(
    (data) =>
      [...(Array.isArray(data) ? data : [])]
        .sort((a, b) =>
          (a.firma || '').localeCompare(
            b.firma || '',
            'tr',
            { sensitivity: 'base' }
          )
        )
        .map((k) => ({
          ...k,
          fotograflar: Array.isArray(k.fotograflar) ? k.fotograflar : []
        })),
    []
  );




  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);




        const res = await fetch('/api/kayitlar');




        if (!res.ok) {
          throw new Error(`Sunucu hatası (HTTP ${res.status})`);
        }




        const data = await res.json();
        setKayitlar(normalizeKayitlar(data));
      } catch (err) {
        console.error('Veri çekme hatası:', err);
        toast.error('❌ Veriler yüklenemedi');
      } finally {
        setLoading(false);
      }
    };




    fetchData();
  }, [normalizeKayitlar]);




  const filtrelenmisKayitlar = useMemo(() => {
    const aramaAnahtari = normalizeTr(filterText);




    if (!aramaAnahtari) return kayitlar;




    return kayitlar.filter((kayit) => {
      const anaAlanEslesme = Object.values(kayit).some(
        (value) =>
          typeof value === 'string' &&
          normalizeTr(value).includes(aramaAnahtari)
      );




      if (anaAlanEslesme) return true;




      return Object.entries(kayit.parcalar || {}).some(
        ([parcaKey, tedarikciler]) =>
          normalizeTr(parcaKey).includes(aramaAnahtari) ||
          (Array.isArray(tedarikciler) &&
            tedarikciler.some((item) =>
              [item.adi, item.kod, item.fiyat, item.adet].some(
                (v) =>
                  v != null &&
                  normalizeTr(v).includes(aramaAnahtari)
              )
            ))
      );
    });
  }, [kayitlar, filterText]);




  const getParcaBilgisiDetayli = useCallback((kayit, key) => {
    const parcalar = kayit.parcalar || {};




    const alan =
      PARCA_ALANLARI.find((a) => a.key === key) ||
      REVIZYON_ALANLARI.find((a) => a.key === key) ||
      ALANLAR.find((a) => a.key === key);




    const hedefAnahtarlar = [
      normalizeTr(key),
      normalizeTr(alan?.label)
    ].filter(Boolean);




    const eslesen = Object.keys(parcalar).find((parcaKey) => {
      const normalizeParcaKey = normalizeTr(parcaKey);




      return hedefAnahtarlar.includes(normalizeParcaKey);
    });




    if (
      !eslesen ||
      !Array.isArray(parcalar[eslesen]) ||
      parcalar[eslesen].length === 0
    ) {
      return <span className="detail-value">-</span>;
    }




    const liste = parcalar[eslesen];




    return (
      <div className="tedarikci-kartlari">
        {liste.map((item, idx) => (
          <div key={item.id || idx} className="tedarikci-kart">
            <div>
              <strong>Kod:</strong> {item.kod || '-'}
            </div>




            <div>
              <strong>Tedarikçi:</strong> {item.adi || '-'}
            </div>




            <div>
              <strong>Fiyat:</strong> {temizFiyat(item.fiyat)} €
            </div>




            <div>
              <strong>Adet:</strong> {item.adet ?? '-'}
            </div>
          </div>
        ))}
      </div>
    );
  }, []);




  const ekParcaAnahtarlari = useMemo(() => {
    if (!detayModal?.parcalar) return [];




    const tanimliAnahtarlar = new Set(
      [...PARCA_ALANLARI, ...REVIZYON_ALANLARI].flatMap((alan) => [
        normalizeTr(alan.key),
        normalizeTr(alan.label)
      ]).filter(Boolean)
    );




    return Object.keys(detayModal.parcalar)
      .filter((parcaKey) => {
        if (!parcaKey) return false;




        const parcalar = detayModal.parcalar[parcaKey];




        if (!Array.isArray(parcalar) || parcalar.length === 0) {
          return false;
        }




        return !tanimliAnahtarlar.has(normalizeTr(parcaKey));
      })
      .sort((a, b) => a.localeCompare(b, 'tr'));
  }, [detayModal]);




  const aksamVerisi = useMemo(() => {
    if (!detayModal) return null;




    const veri = detayModal.aksamlar;




    if (Array.isArray(veri) && veri.length > 0) {
      return veri;
    }




    return null;
  }, [detayModal]);




  const pdfOlustur = useCallback(async (kayit) => {
    if (!kayit) return;




    try {
      const doc = new jsPDF({ format: 'a4', unit: 'mm' });




      const base64Font = await fetchFontBase64('/fonts/DejaVuSans.ttf');




      doc.addFileToVFS('DejaVu.ttf', base64Font);
      doc.addFont('DejaVu.ttf', 'DejaVu', 'normal');




      const fontSec = () => doc.setFont('DejaVu', 'normal');
      fontSec();




      let y = 20;




      doc.setFontSize(16);
      doc.setTextColor(30, 64, 175);
      doc.text('KOMPRESÖR BAKIM KAYDI', 14, y);
      y += 8;




      fontSec();
      doc.setFontSize(11);
      doc.setTextColor(15, 23, 42);




      doc.text(`Firma  : ${kayit.firma || '-'}`, 14, y);
      y += 6;




      doc.text(`Model  : ${kayit.model || '-'}`, 14, y);
      y += 6;




      doc.text(`Seri No: ${kayit.seriNo || '-'}`, 14, y);
      y += 10;




      doc.setFontSize(12);
      doc.text('Tedarikçiler & Parçalar', 14, y);
      y += 8;




      const parcaRows = [];




      Object.entries(kayit.parcalar || {}).forEach(([ad, tedarikciler]) => {
        if (!Array.isArray(tedarikciler)) return;




        tedarikciler.forEach((tedarikci) => {
          parcaRows.push([
            ad,
            tedarikci.adi || '-',
            tedarikci.kod || '-',
            `${temizFiyat(tedarikci.fiyat)} €`,
            tedarikci.adet ?? '-'
          ]);
        });
      });




      autoTable(doc, {
        head: [['PARÇA ADI', 'TEDARİKÇİ', 'KOD', 'FİYAT', 'ADET']],
        body:
          parcaRows.length > 0
            ? parcaRows
            : [['-', '-', '-', '-', '-']],
        startY: y,
        theme: 'grid',
        headStyles: {
          fillColor: [30, 64, 175],
          textColor: 255,
          font: 'DejaVu',
          fontStyle: 'normal'
        },
        bodyStyles: { fontSize: 9, font: 'DejaVu' },
        styles: {
          halign: 'left',
          valign: 'middle',
          font: 'DejaVu'
        }
      });




      const fiyatlar = Object.values(kayit.parcalar || {})
        .flat()
        .map((p) => parseFiyat(p?.fiyat));




      const toplamFiyat = fiyatlar
        .filter((f) => !isNaN(f))
        .reduce((a, b) => a + b, 0);




      const gecersizFiyatSayisi = fiyatlar.filter((f) =>
        isNaN(f)
      ).length;




      let finalY = doc.lastAutoTable?.finalY || y;
      const sayfaYuksekligi = doc.internal.pageSize.getHeight();




      if (finalY + (gecersizFiyatSayisi > 0 ? 32 : 25) > sayfaYuksekligi) {
        doc.addPage();
        finalY = 20;
      }




      fontSec();
      doc.setFontSize(12);
      doc.text(`Toplam Fiyat: ${toplamFiyat.toFixed(2)} €`, 14, finalY + 10);
      doc.text(
        `Belge Tarihi: ${new Date().toLocaleDateString('tr-TR')}`,
        14,
        finalY + 18
      );




      if (gecersizFiyatSayisi > 0) {
        doc.setFontSize(9);
        doc.setTextColor(200, 60, 0);
        doc.text(
          `Dikkat: ${gecersizFiyatSayisi} adet fiyat okunamadı ve toplama dahil edilmedi.`,
          14,
          finalY + 26
        );
      }




      doc.save(`Kompresor_${guvenliDosyaAdi(kayit.firma, kayit.model)}.pdf`);
      toast.success('✅ PDF oluşturuldu');
    } catch (err) {
      console.error('PDF oluşturma hatası:', err);
      toast.error(
        '❌ PDF oluşturulamadı: ' + (err.message || 'Bilinmeyen hata')
      );
    }
  }, []);




  const handleSil = useCallback(
    async (kayit) => {
      const onaylandi = await onayIste(
        `${kayit.firma} - ${kayit.model}\nSeri No: ${kayit.seriNo}\n\nBu kaydı silmek istiyor musunuz?`
      );




      if (!onaylandi) return false;




      try {
        const response = await fetch('/api/kayitlar/sil', {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: kayit.id,
            firma: kayit.firma,
            model: kayit.model,
            seriNo: kayit.seriNo
          })
        });




        const sonuc = await response.json();




        if (response.ok && sonuc.durum === 'ok') {
          setKayitlar((prev) =>
            prev.filter(
              (k) => kayitKimligi(k) !== kayitKimligi(kayit)
            )
          );




          setDetayModal((prev) =>
            prev &&
            kayitKimligi(prev) === kayitKimligi(kayit)
              ? null
              : prev
          );




          toast.success('✅ Kayıt başarıyla silindi');
          return true;
        }




        toast.error('❌ Hata: ' + (sonuc.mesaj || 'Bilinmeyen hata'));
        return false;
      } catch (err) {
        toast.error('❌ Sunucuya ulaşılamadı.');
        console.error(err);
        return false;
      }
    },
    [onayIste]
  );




  const kaydiGuncelle = useCallback(async (kayit) => {
    const res = await fetch('/api/kayitlar/guncelle', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(kayit)
    });




    let sonuc = null;




    try {
      sonuc = await res.json();
    } catch {}




    if (!res.ok || (sonuc?.durum && sonuc.durum !== 'ok')) {
      return false;
    }




    return true;
  }, []);




  const handleFotoEkle = useCallback(
    async (event, kayit) => {
      const input = event.target;
      const dosya = input.files?.[0];




      if (!dosya) return;




      const formData = new FormData();




      formData.append('photo', dosya);
      formData.append('seriNo', kayit.seriNo);




      try {
        const uploadRes = await fetch('/api/upload-photo', {
          method: 'POST',
          body: formData
        });




        const data = await uploadRes.json().catch(() => ({}));




        if (!uploadRes.ok || !data.url) {
          throw new Error(data.error || 'Yükleme başarısız');
        }




        const guncellenmis = {
          ...kayit,
          fotograflar: [...(kayit.fotograflar || []), data.url]
        };




        let guncellendi = false;
        let agHatasi = false;




        try {
          guncellendi = await kaydiGuncelle(guncellenmis);
        } catch (guncellemeHatasi) {
          console.warn(
            'Kayıt güncelleme isteği sonuçlanamadı:',
            guncellemeHatasi
          );
          agHatasi = true;
        }




        if (agHatasi) {
          toast.error(
            '❗ Fotoğraf yüklendi ancak kayıt güncellemesinin sonucu doğrulanamadı.'
          );
          return;
        }




        if (!guncellendi) {
          throw new Error('Kayıt güncellenemedi.');
        }




        setKayitlar((prev) =>
          prev.map((k) =>
            kayitKimligi(k) === kayitKimligi(kayit)
              ? guncellenmis
              : k
          )
        );




        setDetayModal((prev) =>
          prev && kayitKimligi(prev) === kayitKimligi(kayit)
            ? guncellenmis
            : prev
        );




        toast.success('✅ Fotoğraf yüklendi');
      } catch (err) {
        toast.error('❌ Fotoğraf yüklenemedi: ' + err.message);
        console.error(err);
      } finally {
        input.value = '';
      }
    },
    [kaydiGuncelle]
  );




  const handleFotoSil = useCallback(
    async (kayit, fotoIndex) => {
      const onaylandi = await onayIste(
        'Bu fotoğrafı silmek istiyor musunuz?'
      );




      if (!onaylandi) return;




      const fotoUrl = kayit.fotograflar[fotoIndex];




      const guncellenmis = {
        ...kayit,
        fotograflar: kayit.fotograflar.filter(
          (_, i) => i !== fotoIndex
        )
      };




      try {
        const guncellendi = await kaydiGuncelle(guncellenmis);




        if (!guncellendi) {
          throw new Error('Kayıt güncellenemedi.');
        }




        setKayitlar((prev) =>
          prev.map((k) =>
            kayitKimligi(k) === kayitKimligi(kayit)
              ? guncellenmis
              : k
          )
        );




        setDetayModal((prev) =>
          prev && kayitKimligi(prev) === kayitKimligi(kayit)
            ? guncellenmis
            : prev
        );




        toast.success('✅ Fotoğraf silindi');




        try {
          await fetch(
            `/api/upload-photo?url=${encodeURIComponent(fotoUrl)}`,
            { method: 'DELETE' }
          );
        } catch {}
      } catch (err) {
        toast.error('❌ Hata: ' + err.message);
        console.error(err);
      }
    },
    [onayIste, kaydiGuncelle]
  );




  const handleKlonla = useCallback(
    async (kaynak, yeniFirma, yeniSeriNo) => {
      setKlonBekliyor(true);




      try {
        const response = await fetch('/api/kayitlar/klonla', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            kaynakSeriNo: kaynak.seriNo,
            yeniKayitlar: [
              {
                firma: yeniFirma,
                seriNo: yeniSeriNo
              }
            ]
          })
        });




        const sonuc = await response.json();




        if (response.ok && sonuc.durum === 'ok') {
          toast.success(
            `✅ ${sonuc.eklenenler?.length ?? 1} kayıt klonlandı!`
          );




          try {
            const res = await fetch('/api/kayitlar');




            if (!res.ok) throw new Error(`HTTP ${res.status}`);




            setKayitlar(normalizeKayitlar(await res.json()));
          } catch {
            toast.error(
              '⚠️ Kayıt klonlandı ancak liste yenilenemedi.'
            );
          }




          return true;
        }




        toast.error(
          '❌ Klonlama hatası: ' +
            (sonuc.hatalar?.join(', ') ||
              sonuc.mesaj ||
              'Bilinmeyen hata')
        );




        return false;
      } catch {
        toast.error('❌ Sunucuya ulaşılamadı.');
        return false;
      } finally {
        setKlonBekliyor(false);
      }
    },
    [normalizeKayitlar]
  );




  const handleSec = useCallback((kayit) => {
    setDetayModal(kayit);
    setActiveTab('detay');
  }, []);




  const renderBilgiSatiri = (alan) => {
    const { key, label } = alan;




    if (key === 'adres') {
      return (
        <div key={key} className="detail-item full-width">
          <span className="detail-label">
            {getIcon(key)} {label}
          </span>




          {detayModal.adres ? (
            <div className="address-navigation-container">
              <a
                href={
                  detayModal.gpsKoordinat
                    ? `https://www.google.com/maps?q=${detayModal.gpsKoordinat.lat},${detayModal.gpsKoordinat.lng}`
                    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                        detayModal.adres
                      )}`
                }
                target="_blank"
                rel="noopener noreferrer"
                className="address-navigation-link"
              >
                <span className="address-text">
                  {detayModal.adres}
                </span>
              </a>
            </div>
          ) : (
            <span className="detail-value detail-value-empty">
              -
            </span>
          )}
        </div>
      );
    }




    const deger = detayModal[key];
    const bos =
      deger === undefined ||
      deger === null ||
      (typeof deger === 'string' && deger.trim() === '');




    return (
      <div key={key} className="detail-item">
        <span className="detail-label">
          {getIcon(key)} {label}
        </span>




        <span className="detail-value">
          {bos ? '-' : deger}
        </span>
      </div>
    );
  };




  const renderParcaSatiri = (alan) => {
    const { key, label } = alan;




    return (
      <div key={key} className="detail-item full-width">
        <span className="detail-label">
          {getIcon('parca')} {label}
        </span>




        <span className="detail-value">
          {getParcaBilgisiDetayli(detayModal, key)}
        </span>
      </div>
    );
  };




  const renderAksamVerisi = () => {
    if (!aksamVerisi) {
      return (
        <p className="bos-bolum-mesaji">
          Bu kompresör için aksam bilgisi girilmemiş.
        </p>
      );
    }




    return (
      <div className="aksam-kart-listesi">
        {aksamVerisi.map((aksama, idx) => {
          const oringler = Array.isArray(aksama.oringler)
            ? aksama.oringler
            : [];




          const filtreler = Array.isArray(aksama.filtreler)
            ? aksama.filtreler
            : [];




          return (
            <div key={aksama.id || idx} className="aksam-kart">
              <h4 className="aksam-kart-baslik">
                ⭕ {aksama.aksamaTipi || aksama.ad || `Aksama ${idx + 1}`}
              </h4>




              {aksama.notlar ? (
                <div className="aksam-not">
                  <strong>📝 Not:</strong> {aksama.notlar}
                </div>
              ) : null}




              {oringler.length > 0 && (
                <div className="aksam-alt-bolum">
                  <h5 className="aksam-alt-baslik">
                    ⭕ O-Ring’ler ({oringler.length})
                  </h5>




                  <div className="aksam-tablo-sarmal">
                    <table className="aksam-tablo">
                      <thead>
                        <tr>
                          <th>Pozisyon</th>
                          <th>İç Çap</th>
                          <th>Dış Çap</th>
                          <th>Kalınlık</th>
                          <th>Malzeme</th>
                          <th>Kod</th>
                          <th>Adet</th>
                        </tr>
                      </thead>




                      <tbody>
                        {oringler.map((oring, oIdx) => (
                          <tr key={oring.id || oIdx}>
                            <td>{oring.pozisyon || '-'}</td>
                            <td>{oring.icCap ?? '-'}</td>
                            <td>{oring.disCap ?? '-'}</td>
                            <td>{oring.kalinlik ?? '-'}</td>
                            <td>{oring.malzeme || '-'}</td>
                            <td>{oring.kod || '-'}</td>
                            <td>{oring.adet ?? '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}




              {filtreler.length > 0 && (
                <div className="aksam-alt-bolum">
                  <h5 className="aksam-alt-baslik">
                    🔲 Filtreler ({filtreler.length})
                  </h5>




                  <div className="aksam-tablo-sarmal">
                    <table className="aksam-tablo">
                      <thead>
                        <tr>
                          <th>Tip</th>
                          <th>Boyut</th>
                          <th>Kod</th>
                          <th>Tedarikçi</th>
                          <th>Değişim Aralığı</th>
                        </tr>
                      </thead>




                      <tbody>
                        {filtreler.map((filtre, fIdx) => (
                          <tr key={filtre.id || fIdx}>
                            <td>{filtre.tip || '-'}</td>
                            <td>{filtre.boyut || '-'}</td>
                            <td>{filtre.kod || '-'}</td>
                            <td>{filtre.tedarikçi || '-'}</td>
                            <td>{filtre.degisimAraligi || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}




              {oringler.length === 0 &&
                filtreler.length === 0 &&
                !aksama.notlar && (
                  <p className="bos-bolum-mesaji">
                    Bu aksam için O-ring, filtre veya not girilmemiş.
                  </p>
                )}
            </div>
          );
        })}
      </div>
    );
  };




  if (loading) {
    return (
      <div className="compressor-panel">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Kompresör kayıtları yükleniyor...</p>
        </div>
      </div>
    );
  }




  return (
    <div className="compressor-panel">
      <div className="panel-header">
        <h2 className="panel-title">Kompresör Yönetim Sistemi</h2>




        <div className="search-wrapper">
          <input
            type="text"
            placeholder="🔍 Firma, model veya parça ara..."
            className="search-input"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>




        <button
          className="btn-klonla-header"
          onClick={() => setKlonlamaModalAcik(true)}
        >
          📋 Şablondan Klonla
        </button>
      </div>




      <div className="theme-toggle">
        <button
          onClick={() => setDarkMode((prev) => !prev)}
          className="theme-btn"
        >
          {darkMode ? '☀️ Açık Mod' : '🌙 Koyu Mod'}
        </button>
      </div>




      <div className="records-table-container">
        <table className="records-table">
          <thead>
            <tr>
              <th>Firma</th>
              <th>Model</th>
              <th>Seri No</th>
              <th>İşlemler</th>
            </tr>
          </thead>




          <tbody>
            {filtrelenmisKayitlar.map((kayit, i) => (
              <tr
                key={kayitKimligi(kayit) || i}
                className="record-row"
              >
                <td
                  className="company-cell clickable"
                  onClick={() => handleSec(kayit)}
                >
                  {kayit.firma}
                </td>




                <td>{kayit.model}</td>
                <td className="serial-cell">{kayit.seriNo}</td>




                <td className="actions-cell">
                  <button
                    className="action-pdf"
                    onClick={() => pdfOlustur(kayit)}
                  >
                    PDF
                  </button>




                  <button
                    className="action-delete"
                    onClick={() => handleSil(kayit)}
                  >
                    Sil
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>




        {filtrelenmisKayitlar.length === 0 && (
          <p className="no-results">
            🔎 Aradığınız kriterlere uygun kayıt bulunamadı.
          </p>
        )}
      </div>




      {detayModal && (
        <div
          className="modal-overlay"
          onClick={() => setDetayModal(null)}
        >
          <div
            className="modal-content modal-content-large"
            onClick={(e) => e.stopPropagation()}
          >
            {/* KompresorDetay gibi yan yana sekme çubuğu */}
            <div className="detay-sekme-cubugu">
              <div className="detay-sekme-baslik">
                <h3 className="details-title">
                  {detayModal.firma} - {detayModal.seriNo}
                </h3>




                <button
                  className="modal-close"
                  onClick={() => setDetayModal(null)}
                >
                  ×
                </button>
              </div>




              <div className="detay-sekmeler">
                {SEKMELER.map((sekme) => (
                  <button
                    key={sekme.id}
                    type="button"
                    className={`detay-sekme-btn ${
                      activeTab === sekme.id ? 'active' : ''
                    }`}
                    onClick={() => setActiveTab(sekme.id)}
                  >
                    {sekme.label}
                  </button>
                ))}
              </div>
            </div>




            {activeTab === 'detay' && (
              <div className="tab-content">
                <div className="column-section">
                  <h4 className="column-title">
                    👤 Müşteri Bilgileri
                  </h4>




                  <div className="details-grid">
                    {MUSTERI_BILGILERI.map(renderBilgiSatiri)}
                  </div>
                </div>




                <div className="column-section">
                  <h4 className="column-title">
                    ⚙️ Kompresör Bilgileri
                  </h4>




                  <div className="details-grid">
                    {KOMPRESOR_BILGILERI.map(renderBilgiSatiri)}
                  </div>
                </div>




                <div className="column-section">
                  <h4 className="column-title">📝 Özel Notlar</h4>




                  <div className="details-grid">
                    <div className="detail-item full-width">
                      <span className="detail-value">
                        {detayModal.ozelNotlar ? (
                          <button
                            className="not-goruntule-btn"
                            onClick={() =>
                              setOzelNotlarGoruntule(
                                detayModal.ozelNotlar
                              )
                            }
                          >
                            Notu Görüntüle
                          </button>
                        ) : (
                          '-'
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}




            {activeTab === 'parcalar' && (
              <div className="tab-content">
                <div className="column-section">
                  <h4 className="column-title">
                    🔧 Parçalar & Tedarikçiler
                  </h4>




                  <div className="details-grid">
                    {PARCA_ALANLARI.map(renderParcaSatiri)}




                    {ekParcaAnahtarlari.map((parcaKey) => (
                      <div
                        key={parcaKey}
                        className="detail-item full-width"
                      >
                        <span className="detail-label">
                          {getIcon('parca')} {parcaKey}
                        </span>




                        <span className="detail-value">
                          {getParcaBilgisiDetayli(
                            detayModal,
                            parcaKey
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}




            {activeTab === 'aksamlar' && (
              <div className="tab-content">
                <div className="column-section">
                  <h4 className="column-title">
                    ⭕ Aksamlar
                  </h4>




                  {renderAksamVerisi()}
                </div>
              </div>
            )}




            {activeTab === 'revizyon' && (
              <div className="tab-content">
                <div className="column-section">
                  <h4 className="column-title">
                    🛠️ Revizyon / Rulman Grupları
                  </h4>




                  <div className="details-grid">
                    {REVIZYON_ALANLARI.map(renderParcaSatiri)}
                  </div>
                </div>




                <div className="column-section">
                  <h4 className="column-title">
                    📅 Revizyon Bilgisi
                  </h4>




                  <div className="details-grid">
                    <div className="detail-item">
                      <span className="detail-label">
                        Revizyon Saati
                      </span>




                      <span className="detail-value">
                        {detayModal.revizyonSaat || '-'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}




            {activeTab === 'gallery' && (
              <div className="photos-section">
                <div className="photo-upload">
                  <input
                    type="file"
                    accept="image/*"
                    id={`photo-upload-${kayitKimligi(detayModal)}`}
                    onChange={(e) =>
                      handleFotoEkle(e, detayModal)
                    }
                    style={{ display: 'none' }}
                  />




                  <label
                    htmlFor={`photo-upload-${kayitKimligi(
                      detayModal
                    )}`}
                    className="upload-btn"
                  >
                    ➕ Fotoğraf Yükle
                  </label>
                </div>




                <div className="photo-grid">
                  {detayModal.fotograflar &&
                  detayModal.fotograflar.length > 0 ? (
                    detayModal.fotograflar.map((foto, idx) => (
                      <div key={idx} className="photo-item">
                        <img
                          src={foto}
                          alt={`Kompresör ${idx + 1}`}
                          className="photo-img"
                          onClick={() => {
                            setAktifFoto(foto);
                            setZoomMode('fit');
                          }}
                        />




                        <button
                          className="photo-delete"
                          onClick={() =>
                            handleFotoSil(detayModal, idx)
                          }
                        >
                          ×
                        </button>
                      </div>
                    ))
                  ) : (
                    <p className="photo-empty">
                      Henüz fotoğraf eklenmemiş.
                    </p>
                  )}
                </div>
              </div>
            )}




            <div className="modal-footer">
              <button
                className="modal-pdf-btn"
                onClick={() => {
                  pdfOlustur(detayModal);
                  setDetayModal(null);
                }}
              >
                PDF İndir
              </button>




              <button
                className="modal-delete-btn"
                onClick={() => handleSil(detayModal)}
              >
                Kaydı Sil
              </button>
            </div>
          </div>
        </div>
      )}




      {ozelNotlarGoruntule !== null && (
        <div
          className="modal-overlay modal-overlay-high"
          onClick={() => setOzelNotlarGoruntule(null)}
        >
          <div
            className="modal-content modal-notlar"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-notlar-header">
              <h3>📝 Özel Notlar</h3>




              <button
                className="modal-close-btn"
                onClick={() => setOzelNotlarGoruntule(null)}
              >
                ×
              </button>
            </div>




            <div className="modal-notlar-content">
              {ozelNotlarGoruntule}
            </div>
          </div>
        </div>
      )}




      {/* LIGHTBOX — portal ile body'e render, her zaman en üstte */}
      {aktifFoto &&
        createPortal(
          <div
            className="lightbox-overlay"
            style={{
              position: 'fixed',
              inset: 0,
              zIndex: 999999,
              background: 'rgba(0, 0, 0, 0.9)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={() => {
              setAktifFoto(null);
              setZoomMode('fit');
            }}
          >
            <button
              className="lightbox-close"
              onClick={(e) => {
                e.stopPropagation();
                setAktifFoto(null);
                setZoomMode('fit');
              }}
            >
              ×
            </button>




            <img
              src={aktifFoto}
              alt="Büyük Görüntü"
              className={`lightbox-img ${zoomMode}`}
              onClick={(e) => {
                e.stopPropagation();




                setZoomMode((prev) =>
                  prev === 'fit'
                    ? 'zoom-in'
                    : prev === 'zoom-in'
                    ? 'zoom-out'
                    : 'fit'
                );
              }}
            />
          </div>,
          document.body
        )}




      <KlonlamaModal
        acik={klonlamaModalAcik}
        kapat={() => setKlonlamaModalAcik(false)}
        kaynakKayitlar={kayitlar}
        onKlonla={handleKlonla}
        bekliyor={klonBekliyor}
      />




      <OnayModal
        acik={onay !== null}
        mesaj={onay?.mesaj}
        onCevap={onayCevapla}
      />
    </div>
  );
};




const getIcon = (key) => {
  const defaultIcon = (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="inline-icon"
    >
      <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10ZM12 18C13.1 18 14 18.9 14 20C14 21.1 13.1 22 12 22C10.9 22 10 21.1 10 20C10 18.9 10.9 18 12 18Z" />
    </svg>
  );




  const icons = {
    seperator: defaultIcon,
    yagFiltresi: defaultIcon,
    havaFiltresi: defaultIcon,
    adres: defaultIcon,
    mail: defaultIcon,
    bakimTarihi: defaultIcon,
    sonBakimTarihi: defaultIcon,
    imalYili: defaultIcon,
    parca: defaultIcon
  };




  return icons[key] || defaultIcon;
};




export default KompresorListesi;